import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "../common/Select";
import TextArea from "../common/TextArea";
import moment from "moment";

function Comment({ showModal, onHide, fields, onSave, commentToEdit }) {
  const [selectedField, setSelectedField] = useState("EntireForm");
  const [comment, setComment] = useState("");

  useEffect(() => {
    document.addEventListener("focus", handleFocusChange, true);

    return () => {
      document.removeEventListener("focus", handleFocusChange, true);
    };
  }, []);

  useEffect(() => {
    if (commentToEdit) {
      setSelectedField(commentToEdit.field._text);
      setComment(commentToEdit.comment._text);
    }
  }, [commentToEdit]);

  const handleFocusChange = () => {
    if (document.activeElement.name)
      setSelectedField(document.activeElement.name);
  };

  const handleFieldOnChange = ({ currentTarget: input }) => {
    setSelectedField(input.value);
  };

  const handleCommentOnChange = ({ currentTarget: input }) => {
    setComment(input.value);
  };

  const handleSaveComment = () => {
    if (commentToEdit) {
      const commentXml = `<comment><createdby>${commentToEdit.createdby._text}</createdby><datetime>${commentToEdit.datetime._text}</datetime><field>${commentToEdit.field._text}</field><comment>${comment}</comment></comment>`;
      onSave(commentXml, commentToEdit);
    } else {
      const commentXml = `<comment><createdby>${
        JSON.parse(localStorage.getItem("safyInfo")).user.displayName
      }</createdby><datetime>${moment().format(
        "LLL"
      )}</datetime><field>${selectedField}</field><comment>${comment.replace(
        "&",
        "and"
      )}</comment></comment>`;
      onSave(commentXml);
    }

    setSelectedField("");
    setComment("");
  };

  const handleHideModal = (e) => {
    onHide(e);
    setSelectedField("");
    setComment("");
  };

  return (
    <>
      {showModal ? (
        <Modal show={showModal} animation={false}>
          <Modal.Header>
            <Modal.Title>
              {commentToEdit ? "Edit Comment" : "Add Comment"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              className="m-2"
              label="Comment for"
              value={selectedField}
              options={fields}
              onChange={handleFieldOnChange}
            />
            <TextArea
              label="Comment"
              value={comment}
              onChange={handleCommentOnChange}
            />
            <div>
              <button
                className="btn btn-primary m-2"
                onClick={(event) => {
                  event.preventDefault();
                  handleSaveComment();
                }}
              >
                Save
              </button>
              <button
                className="btn btn-secondary m-2"
                onClick={handleHideModal}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
}

export default Comment;
